import script from "./ContentVariables.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContentVariables.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__